/**
 * cache.js
 * Gestión de caché local de recetas usando IndexedDB.
 * Permite que la app funcione sin conexión en modo lectura.
 */

const DB_NOMBRE = 'cocina-pwa';
const DB_VERSION = 1;
const STORE = 'recetas';

// ── Abrir / crear la base de datos ────────────────────

function abrirDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NOMBRE, DB_VERSION);

    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id' });
      }
    };

    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror = (e) => reject(e.target.error);
  });
}

// ── Guardar recetas en caché ──────────────────────────

export async function guardarRecetasEnCache(recetas) {
  try {
    const db = await abrirDB();
    const tx = db.transaction(STORE, 'readwrite');
    const store = tx.objectStore(STORE);

    // Limpiar caché anterior y guardar las nuevas
    store.clear();
    recetas.forEach((r) => store.put(r));

    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = (e) => reject(e.target.error);
    });
  } catch (error) {
    // Si falla el caché no es crítico — la app sigue funcionando
    console.warn('[Cache] Error al guardar:', error);
  }
}

// ── Leer recetas del caché ────────────────────────────

export async function leerRecetasDeCache() {
  try {
    const db = await abrirDB();
    const tx = db.transaction(STORE, 'readonly');
    const store = tx.objectStore(STORE);

    return new Promise((resolve, reject) => {
      const req = store.getAll();
      req.onsuccess = (e) => resolve(e.target.result);
      req.onerror = (e) => reject(e.target.error);
    });
  } catch (error) {
    console.warn('[Cache] Error al leer:', error);
    return [];
  }
}
